import { useTheme } from "@/context/ThemeContext";
import { useLanguage } from "@/context/LanguageContext";
import { carDetailsLabels } from "@/i18n";

interface ServiceEntryProps {
  date: string;
  mileage: string;
  serviceType?: string;
  notes?: string;
  images?: string[];
}

const ServiceEntry = ({ date, mileage, serviceType, notes }: ServiceEntryProps) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  const { language } = useLanguage();
  const labels = carDetailsLabels(language).serviceHistory;

  return (
    <div
      className={
        isDark
          ? "bg-black/20 rounded-lg"
          : "bg-white/90 border border-gray-200 rounded-lg"
      }
    >
      <div className="p-4">
        <div className="flex flex-col space-y-2">
          <div className="flex justify-between items-center">
            <span className={"text-sm md:text-sm text-primary/60"}>{labels.date}:</span>
            <span className={"text-sm md:text-sm"}>{date}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className={"text-sm md:text-sm text-primary/60"}>
              {labels.mileage}:
            </span>
            <span className={"text-sm md:text-sm"}>{mileage} {labels.miles}</span>
          </div>
          {serviceType && (
            <div className="flex justify-between items-center">
              <span className={"text-sm md:text-sm text-primary/60"}>
                {labels.performed}:
              </span>
              <span className={"text-sm md:text-sm"}>{serviceType}</span>
            </div>
          )}
          {notes && (
            <div className="flex flex-col space-y-1 mt-2">
              <span className={"text-sm md:text-sm text-primary/60"}>
                {labels.comment}:
              </span>
              <span className={"text-sm md:text-sm whitespace-pre-wrap"}>{notes}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceEntry;
